import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Button } from '@material-ui/core';
import { loadTexts } from '../../../../config/texts';
const TEXT_KEY = "organization";

const styles = theme => ({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
  },
});

class Section extends React.Component {
  _onCancel = () => {
    this.props.onCancel();
  };

  _onSave = () => {
    this.props.onSave();
  };

  render() {
    const {
      cancelDisabled,
      saveDisabled,
      children,
      classes,
      locale
    } = this.props;
    const texts = loadTexts(TEXT_KEY, locale)
    return (
      <Paper>
        {children}
        <div className={classes.buttonContainer}>
          <Button disabled={cancelDisabled} onClick={this._onCancel}>
            {texts.section.cancel}
          </Button>
          <Button color="primary" disabled={saveDisabled} onClick={this._onSave}>
            {texts.section.save}
          </Button>
        </div>
      </Paper>
    );
  }
}

Section.propTypes = {
  cancelDisabled: PropTypes.bool.isRequired,
  saveDisabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  children: PropTypes.any,
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'Section' }),
  connect(mapStateToProps, {})
)(Section);



// WEBPACK FOOTER //
// ./src/modules/organization/cards/Section/index.js